import React, { useRef, useEffect } from "react";
import "./our-brands.css";

import LoanOnSalaryBrand from "../assets/images/Loanonsalary_brand.png";
import LoanOnTipBrand from "../assets/images/Loanontip_brand.png";
import FundswalleBrand from "../assets/images/Fundswalle_brand.png";
import DhanwalleBrand from "../assets/images/Dhanwalle_brand.png";
import RupyaBrand from "../assets/images/rupya_logo.png";

const OurBrands = () => {
  const scrollRef = useRef(null);
  let scrollSpeed = 0.5;

  useEffect(() => {
    const container = scrollRef.current;
    let reqId;

    const autoScroll = () => {
      if (container) {
        container.scrollLeft += scrollSpeed;
        // seamless loop
        if (container.scrollLeft >= container.scrollWidth / 2) {
          container.scrollLeft = 0;
        }
      }
      reqId = requestAnimationFrame(autoScroll);
    };

    autoScroll();
    return () => cancelAnimationFrame(reqId);
  }, []);

  const handleMouseEnter = () => { scrollSpeed = 0; };
  const handleMouseLeave = () => { scrollSpeed = 0.5; };

  const logos = [DhanwalleBrand, FundswalleBrand, LoanOnSalaryBrand, LoanOnTipBrand, RupyaBrand];

  return (
    <section className="brands-section">
      <div className="brands-background"></div>

      <div className="container py-4 py-md-5 content-wrapper">
        <h2 className="h4 performance-title text-dark mb-2">
          <span className="brand-title">Our Brand Partners</span>
        </h2>

        <p className="section-subtitle text-center">
          Thoughtfully designed experiences where end users feel connected 
          and empowered. Each brand is a reflection of purpose, usability, 
          and joy.
        </p>

        <div 
          className="brand-scroll-container" 
          ref={scrollRef} 
          onMouseEnter={handleMouseEnter} 
          onMouseLeave={handleMouseLeave}
        >
          <div className="brand-marquee">
            {[...logos, ...logos].map((logo, idx) => (
              <div key={idx} className="brand-item text-center">
                <img src={logo} alt={`Brand partner ${idx + 1}`} className="brand-logo" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurBrands;
